export default (request, next) => {
  next(response => {
    let data
    let contentType = response.headers.get('content-type')
    if (typeof contentType === 'string' && contentType.indexOf('application/json') === 0) {
      data = response.body
    } else {
      try {
        data = JSON.parse(response.bodyText)
      } catch (e) {
        data = null
      }
    }
    // eslint-disable-next-line no-prototype-builtins
    if (data !== null && data.hasOwnProperty('data') && Object.keys(data).length === 1) {
      data = data.data
    }
    response.body = data
    return response
  })
}
